import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ACTOR_VOICES_QUERY_KEYS } from "Actors/Api/Queries/actorVoicesQueryKeys";
import {
  postActorsActorIDActorVoices,
  type SaveActorVoiceRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export function useCreateActorVoiceMutation(actorID: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((request: SaveActorVoiceRequest) =>
      postActorsActorIDActorVoices(request, actorID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ACTOR_VOICES_QUERY_KEYS.all(actorID),
      });
    },
  });
}
